// extracted by mini-css-extract-plugin
module.exports = {"container":"safe-index_container_2Xpsb","noDataBox":"safe-index_noDataBox_30RZ9","icon":"safe-index_icon_2bvVe","chartBox":"safe-index_chartBox_3txic"};